module.exports = __webpack_public_path__ + "img/G1.a2fd95bd.png";